import ROUTE from 'constant/route'
import usePermission from 'hooks/usePermission/usePermission'
import { Redirect, RouteProps } from 'react-router-dom'
import { useAppSelector } from 'store/useStoreHook'
import SplashScreenPage from 'pages/SplashPage'
import NoPermission from 'pages/NoPermissionPage'
import { ModuleNames, TerminalOperationSetting } from 'interfaces'
import { ClientType } from 'models'
import ClientRoute from './ClientRoute'
import useAuth from 'hooks/useAuth/useAuth'
import { AuthorizationState } from 'store/models/authModels'

interface PermissionRouteProps extends RouteProps {
    permissions?: number[]
    operationalSetting?: ModuleNames
    terminalSetting?: TerminalOperationSetting
    visibleToClientType?: ClientType[]
}

function PermissionRoute(props: PermissionRouteProps) {
    const {
        component,
        permissions = [],
        operationalSetting,
        visibleToClientType,
        children,
        ...other
    } = props
    const Component: any = component

    const { hasPermission } = usePermission()

    const operationSettingData = useAppSelector((state) => state.operation.data)
    const currentClient = useAppSelector((state) => state.client.currentClient)
    const access = hasPermission(permissions)
    const authState = useAppSelector((state) => state.auth.authState)

    const { isAuthorizing } = useAuth()

    const handleOperational = () => {
        if (operationalSetting) {
            if (operationSettingData[operationalSetting] !== undefined) {
                return operationSettingData[operationalSetting]
            }
        }

        return true
    }

    const disallowedClientType = () =>
        visibleToClientType &&
        (!currentClient || !visibleToClientType.includes(currentClient.type!))

    return access ? (
        <ClientRoute
            {...other}
            render={(): any => {
                if (isAuthorizing) return <SplashScreenPage />

                if (authState === AuthorizationState.ERROR_AUTH) {
                    return <Redirect to={ROUTE.LOGIN} />
                }

                if (!handleOperational() || disallowedClientType()) {
                    return <Redirect to={ROUTE.NOT_FOUND} />
                }

                return children ? children : <Component />
            }}
        />
    ) : (
        <NoPermission />
    )
}

export default PermissionRoute
